import { Injectable } from "@angular/core";
import { EbrApiClient } from "./ebr-api-client/ebr-api-client.service";
import { CurrencyDefinition, RecognizedCurrencyCode } from "./ebr-api-client/ebr-api-client.g";


@Injectable({
  providedIn: 'root',
})
export class CurrencyService {

    constructor(
        private ebrApiClient: EbrApiClient
    ) { }

    async getCurrencies(): Promise<CurrencyDefinition[]> {
        // TODO: Modify the API to customize the generated method name so that it is named as getCurrencies instead of getCurrencyCurrencies
        const response = await this.ebrApiClient.getCurrencyCurrencies(undefined, undefined, undefined);
        const { data } = response;
        return data ?? [];
    }

    async getCurrencyConversionRate(fromCurrency: RecognizedCurrencyCode, toCurrency: RecognizedCurrencyCode): Promise<number> {
        const response = await this.ebrApiClient.getCurrencyConversionRate(fromCurrency, toCurrency, undefined, undefined, undefined);
        return response.data ?? 1;
    }

}